<template>
    <div>
        <v-autocomplete
                label="استان"
                v-model="province_id"
                :items="provinces"
                item-text="name"
                item-value="id"
                clearable
                outlined
                required
                dense
                clear-icon="mdi-close-circle-outline"
                prepend-inner-icon="fa fa-pencil-alt"
                class="mt-1"
        ></v-autocomplete>
    </div>
</template>

<script>
import {Axios2, Bus} from "../../../main";

export default {
    name: "provinceSelector",
    data() {
        return {
            provinces:[],
            province_id:null
        }
    },
    methods: {
        getProvince() {
            Axios2.get('/provinces').then((response) => {
                this.provinces = response.data.data;
            })
        },
    },
    watch: {
        province_id: {
            handler: function (value) {
                Bus.$emit('getProvince',value);
                Bus.$emit('change_province',value);
            }
        }
    },
    created() {
        this.getProvince();
    }
}
</script>

<style scoped>

</style>